import React, { PropTypes } from 'react';
import classnames from 'classnames';
import EmailSubscriptionForm from 'landing_pages/components/email_subscription_form';
import EmailSubscriptionForm2 from 'landing_pages/components/email_subscription_form_2';
import { trackGoogle } from 'common/tracking';

const trackSubscription = (action, label) => {
  trackGoogle("subscribed_email", action, label);
}

const SubscriptionHero = ({
  image, pretitle, title, subtitle, content_html, action_url, security_code, submit_label,
  promo, className, formTitle, formClassName, background, introAlignment='center',
  showSingleNameField, hideNameFields, notice, contentAlignment='center',
  pageUrlStem, successTitle, blockType, redirectUrl, csTag, extraFields
}) => {

  const Form = csTag? EmailSubscriptionForm2 : EmailSubscriptionForm;

  return (
    <section className={classnames('block block-subs-hero', className, background, {
      'without-image': !image
    })} id="subs_hero">

      <div className={`row intro-wrapper align-${introAlignment}`}>
        <div className={classnames("columns small-16 intro", { "large-10": !!image })}>
          { !!pretitle && <div className="as-h3-important pretitle">{ pretitle }</div> }
          <h2 className="title">{ title }</h2>
          { subtitle && <h3 className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} /> }
        </div>
      </div>

      { !!image &&
      <div className='row'>
        <div className="columns small-16 large-8 large-order-2">
          <div className="artwork-container">
            <img src={image.url} alt={image.alt}/>
          </div>
        </div>
        <div className="columns small-16 large-8 large-order-1">
          <div className="hero-content" dangerouslySetInnerHTML={{ __html: content_html }} />
        </div>
      </div> }

      <div className="subscribe-form">
        <div className="row form-row">
          <div className={classnames("columns small-16", { "large-6": !image })}>
            { redirectUrl?
            <a target="_blank" className="btn btn-tertiary" href={redirectUrl}>{ submit_label }</a> :
            <Form
              align={!image? `align-${contentAlignment}` : undefined}
              action_url={action_url}
              security_code={security_code}
              submit_label={submit_label}
              callback={trackSubscription.bind(null, blockType, (title || "").toLowerCase())}
              promo={promo}
              className={formClassName}
              background={background}
              showSingleNameField={showSingleNameField}
              hideNameFields={hideNameFields}
              notice={notice}
              pageUrlStem={pageUrlStem}
              formTitle={formTitle}
              successTitle={successTitle}
              csTag={csTag}
              fullWidth={!image}
              extraFields={extraFields}
            /> }
          </div>
          { !image &&
          <div className="columns small-16 large-offset-1 large-9 hero-content-wrapper">
            <div className="hero-content" dangerouslySetInnerHTML={{ __html: content_html }} />
          </div> }
        </div>
      </div>

    </section>
  );
}

SubscriptionHero.propTypes = {
  pretitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  content_html: PropTypes.string,
  image: PropTypes.object,
  className: PropTypes.string,
  formTitle: PropTypes.string,
  background: PropTypes.string,
  introAlignment: PropTypes.string,
  contentAlignment: PropTypes.string,
  notice: PropTypes.string,
  showSingleNameField: PropTypes.bool,
  hideNameFields: PropTypes.bool,
  pageUrlStem: PropTypes.string.isRequired,
  successTitle: PropTypes.string,
  blockType: PropTypes.string.isRequired,
  redirectUrl: PropTypes.string,
  csTag: PropTypes.string,
  extraFields: PropTypes.array,
};

export default SubscriptionHero;
